import React from "react";

import HistoryActivityCommon, { type HistoryActivityProps as HistoryPropsCommon } from "@common/components/Activity/History";
import { uuid } from "@common/lib/misc";
import { type HistoryItem } from "./types";

type HistoryProps = Omit<HistoryPropsCommon, "get"> & {
  history: HistoryItem[];
};

export const HistoryActivity = (props: HistoryProps) => {
  const hash = React.useMemo(() => uuid(), [props.history]);

  const get = React.useCallback(() => Promise.resolve(props.history), [props.history]);

  return (
    <HistoryActivityCommon
      {...props}
      key={hash}
      isBorderless
      isNarrow
      imageSize={"2em"}
      className="history_activity"
      get={get}
    />
  );
};
